document.addEventListener('DOMContentLoaded', function(){
  try {
    var CUT_HOUR=12, CUT_MIN=30;
    var MIN_TRANSIT=1, MAX_TRANSIT=2;
    var tz='Europe/Rome';

    function easterDate(y){var a=y%19,b=Math.floor(y/100),c=y%100,d=Math.floor(b/4),e=b%4,f=Math.floor((b+8)/25),
    g=Math.floor((b-f+1)/3),h=(19*a+b-d-g+15)%30,i=Math.floor(c/4),k=c%4,l=(32+2*e+2*i-h-k)%7,m=Math.floor((a+11*h+22*l)/451),
    month=Math.floor((h+l-7*m+114)/31),day=((h+l-7*m+114)%31)+1;return new Date(Date.UTC(y,month-1,day));}
    function italianHolidays(year){var set=new Set();function add(y,m,d){set.add(`${y}-${String(m+1).padStart(2,'0')}-${String(d).padStart(2,'0')}`);}
      add(year,0,1);add(year,0,6);add(year,3,25);add(year,4,1);add(year,5,2);add(year,7,15);add(year,10,1);add(year,11,8);add(year,11,25);add(year,11,26);
      var e=easterDate(year),p=new Date(e.getTime()+86400000);add(p.getUTCFullYear(),p.getUTCMonth(),p.getUTCDate());return set;}

    function toRomeNow(){
      var parts=new Intl.DateTimeFormat('it-IT',{timeZone:tz,year:'numeric',month:'2-digit',day:'2-digit',hour:'2-digit',minute:'2-digit',second:'2-digit',hour12:false}).formatToParts(new Date());
      var map=Object.fromEntries(parts.map(p=>[p.type,p.value]));
      // Non fissiamo manualmente l’offset: lasciamo al browser la conversione
      return new Date(`${map.year}-${map.month}-${map.day}T${map.hour}:${map.minute}:${map.second}`);
    }

    // BUG FIX qui 👇
    function ymd(d){
      return `${d.getFullYear()}-${String(d.getMonth()+1).padStart(2,'0')}-${String(d.getDate()).padStart(2,'0')}`;
    }

    function isWeekend(d){var w=d.getDay();return w===0||w===6;}
    function nextBusinessDay(d,set){var n=new Date(d);do{n.setDate(n.getDate()+1);}while(isWeekend(n)||set.has(ymd(n)));return n;}
    function addBusinessDays(d,days,set){var n=new Date(d);while(days>0){n=nextBusinessDay(n,set);days--;}return n;}
    function fmtRangeDate(d){return d.toLocaleDateString('it-IT',{timeZone:tz,weekday:'short',day:'2-digit',month:'short'});}
    function weekdayName(d){return d.toLocaleDateString('it-IT',{timeZone:tz,weekday:'long'}).toLowerCase();}
    function diffDays(a,b){var aa=new Date(a.getFullYear(),a.getMonth(),a.getDate(),12,0,0);var bb=new Date(b.getFullYear(),b.getMonth(),b.getDate(),12,0,0);return Math.round((aa-bb)/86400000);}

    var now=toRomeNow();
    var holidaysThis=italianHolidays(now.getFullYear());
    var holidaysNext=italianHolidays(now.getFullYear()+1);
    function setFor(d){return d.getFullYear()===now.getFullYear()?holidaysThis:holidaysNext;}
    function businessToday(d){return !isWeekend(d) && !setFor(d).has(ymd(d));}

    var cutoff=new Date(now);cutoff.setHours(CUT_HOUR,CUT_MIN,0,0);
    var beforeCut=now.getTime()<=cutoff.getTime();
    var shipDate=(beforeCut&&businessToday(now))?new Date(now):nextBusinessDay(now,setFor(now));
    var earliestDelivery=addBusinessDays(shipDate,MIN_TRANSIT,setFor(shipDate));
    var latestDelivery=addBusinessDays(shipDate,MAX_TRANSIT,setFor(shipDate));

    function cutoffLabel(){ if(businessToday(now)&&beforeCut) return 'oggi';
      var nb=nextBusinessDay(now,setFor(now)); var daysAhead=diffDays(nb,now);
      if(now.getDay()===5 && !beforeCut) return weekdayName(nb);
      if(daysAhead===1) return 'domani'; return weekdayName(nb);
    }

    var elRange=document.getElementById('ltz-window');
    if(elRange) elRange.textContent=`${fmtRangeDate(earliestDelivery)} - ${fmtRangeDate(latestDelivery)}`;

    var elCut=document.getElementById('ltz-cutoff-line');
    if(elCut) elCut.textContent=`Ordina entro le 12:30 di ${cutoffLabel()} e riceverai il pacco (salvo ritardi dello spedizioniere) tra ${fmtRangeDate(earliestDelivery)} e ${fmtRangeDate(latestDelivery)}`;
  } catch(e){
    console.error('ltz-ship error:', e);
  }
});
